import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import ICON_EXAHNGE from "@/assets/images/exchange_succes.png";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  name: 'IntegralExchange',
  setup(__props, { expose }) {
  expose();

_useCssVars(_ctx => ({
  "783d9308-primaryColor": (primaryColor)
}))

const route = useRoute();
const router = useRouter();
let { score, total_score } = route.query;

const { t } = useI18n();

const primaryColor = '#0D0D0D';
onMounted(() => { });

const __returned__ = { route, router, score, total_score, t, primaryColor, ICON_EXAHNGE }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})